module.exports = __webpack_public_path__ + "static/nswdoi-logo-aa9fd52e6fb261b69bb2f4f085c0f05c.svg";